import React, { useState } from 'react';
import CallOut from '../../Common/CallOut';
import { useTheme } from '../../../DataStore/ThemeContext';
import { useReport } from '../../../DataStore/ReportContext';


const ReportProperties = ({reportInfo}) => {
  const [notify, setNotify] = useState(null);
  const {openSettings} = useTheme();
  const { setAutoCommentControl, getReports } = useReport();

  const handleComment = () =>{
    openSettings("Report Comments", "ReportComment", reportInfo);
  }

  const handleAutoComment = () =>{
    setAutoCommentControl({
    show: true,
    report: reportInfo,
    enable: true, // or false
    callback: getReports,
});
  }
 
  return (
    <div className="card-body">
      <CallOut
        title={reportInfo.title}
        description={`Class: ${reportInfo.class.class_name} Term: ${reportInfo.term.term} Year: ${reportInfo.year}`}
      />
      {notify}


       
        
                  <strong><i className="fas fa-pencil-alt mr-1"></i> Report Exams</strong>
                  {/* <button
                    onClick={()=>handleChange(ACTIONS.REPORT_EXAMS)} 
                    className="btn btn-sm btn-primary" 
                    style={{float:'right'}}>Change</button> */}
    
                    <ol className='list-description text-muted'>
                        {reportInfo.report_tests && reportInfo.report_tests.map((item, key)=>
                         <li key={key}><span className="" style={{fontSize: '13px'}}>{item.test.exam_name}/{item.out_of_exact}</span></li>
                        )}
                    </ol>
    
                  <hr/>
    
                  <strong><i className="fas fa-file mr-1"></i> Report Format</strong>
                  {/* <button className="btn btn-sm btn-primary" style={{float:'right'}}>Change</button> */}
    
                  <p className="text-muted">{reportInfo.report_format && reportInfo.report_format.format_name + "(" + reportInfo.report_format.description + ")"}</p>
    
                  <hr/>
    
                  <strong><i className="far fa-file-alt mr-1"></i> Report Comments</strong>
                  <button 
                    className="btn btn-sm btn-primary"
                    onClick={handleComment}
                    style={{float:'right'}}>Change</button>
    
                  <p className="text-muted">Report comments represent general and specific remarks summarise the student performance and any other communication</p>
               
               
                <hr/>
    
                  <strong><i className="fa fa-signal mr-1"></i> Primary Grading</strong>
    
                  <p className="text-muted">{reportInfo.primary_scale && reportInfo.primary_scale.title}</p>
               
               
                <hr/>
    
                  <strong><i className="fa fa-signal mr-1"></i> Secondary Grading</strong>
    
                  <p className="text-muted">{reportInfo.advanced_scale && reportInfo.advanced_scale.scale_name + "(" + reportInfo.advanced_scale.description + ")"}</p>
    
                <hr/>
                   <strong><i className="fa fa-book mr-1"></i> Areas Of Integration</strong>
                   {/* <button className="btn btn-sm btn-primary" style={{float:'right'}}>Change</button> */}
    
                  <p className="text-muted">N/A</p>

                <hr/>
                   <strong><i className="fa fa-comment mr-1"></i> School Fees Comments</strong>
                   <button className="btn btn-sm btn-light" style={{float:'right'}}>Sync Now</button>
                    
                    {/* <button className="btn btn-sm btn-primary" style={{float:'right'}}>
                        <ActivityLoader inline={true} size={20} color="#FFFFFF"/>
                   </button> */}

                  <p className="text-muted">Automatically populate school fees balance and next term fees comments. This only works if your academics system is linked to YEXP Accounting system.</p>
               

                  
                <hr/>
                   <strong><i className="fa fa-user-shield mr-1"></i> Automatic Comments</strong>
                   <button className={`btn btn-sm btn-${reportInfo.auto_comment * 1 ? 'success' : 'danger'}`} style={{float:'right'}} onClick={handleAutoComment}>{reportInfo.auto_comment * 1 ? 'Disable' : 'Enable'}</button>
                    
                    {/* <button className="btn btn-sm btn-primary" style={{float:'right'}}>
                        <ActivityLoader inline={true} size={20} color="#FFFFFF"/>
                   </button> */}

                  <p className="text-muted">Control the automatic comments for the report. This feature allows you to manage predefined comments that can be applied based on student performance and other criteria.</p>
               

                </div>
             
  );
};

export default ReportProperties;
